<template>
  <div>
    <base-material-card v-if="!hideEmpty || tableData.length > 0" :renderCard="card" color="secondary"
      icon="mdi-certificate-outline" :title="computedTitle">
      <v-row>
        <v-col cols="12">
          <data-tables :headers="headers" :table-data="tableData" @showCertificate="showCertificate"
            @deleteCertificate="deleteCertificate" @approveDocument="approveDocument" @rejectDocument="rejectDocument" />
        </v-col>
      </v-row>
    </base-material-card>
    <v-row v-if="mode !== '2approve' && mode !== 'active'">
      <v-col cols="12">
        <base-material-card color="secondary" icon="mdi-upload" :title="$t('upload_certificate')">
          <document-uploader :url="urlUpload" @uploaded="emitUpload" />
        </base-material-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import documentUploader from "@/widget/documentUploader.vue";
import Swal from "sweetalert2";
export default {
  name: "ListCertificati",
  components: {
    DataTables,
    documentUploader,
  },
  props: {
    hideEmpty: false,
    card: false,
    masterId: null,
    mode: null,
  },
  data() {
    return {
      title: null,
      headers: [],
      propsToSearch: ["text"],
      tableData: [],
      urlUpload: "/auth/documenti/upload/certificato/",
      RBAC_VALIDATE: false,
      RBAC_VIEW: false,
      RBAC_DELETE: false,
    };
  },
  watch: {
    masterId: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadTable();
    },
  },
  computed: {
    computedTitle: function () {
      if (this.mode === "2approve") return this.$t('cert_2_approve')
      if (this.mode === "active") return this.$t('active_certificates')
      return this.$t('certificates')
    }
  },
  created() {
    this.RBAC_VALIDATE = this.checkUserRole("documenti", "VALIDATE");
    this.RBAC_VIEW = this.checkUserRole("documenti", "VIEW");
    this.RBAC_DELETE = this.checkUserRole("documenti", "DELETE");
    this.loadTable();
  },
  methods: {
    deleteCertificate(item) {
      const _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          this.chiamataAxios(
            "DELETE",
            "/auth/documenti/deleteDocumento/certificato/" +
            item.masterId +
            "/" +
            item.docId,
            { dialogLoader: true }
          ).then((response) => {
            if (response.msg.esito) {
              let html = "<strong>" + response.msg.msgTxt + "</strong>"
              Swal.fire({
                type: "success",
                html: html,
              });
              _.loadTable();
            }
          });
        }
      });
    },
    approveDocument(item) {
      const _ = this;
      this.chiamataAxios(
        "POST",
        "/auth/documenti/validateDocumento/certificato/" +
        item.masterId +
        "/" +
        item.docId +
        "/1",
        { dialogLoader: true }
      ).then((response) => {
        if (response.msg.esito) _.loadTable();
      });
    },
    rejectDocument(item) {
      const _ = this;
      this.chiamataAxios(
        "POST",
        "/auth/documenti/validateDocumento/certificato/" +
        item.masterId +
        "/" +
        item.docId +
        "/0",
        { dialogLoader: true }
      ).then((response) => {
        if (response.msg.esito) _.loadTable();
      });
    },
    showCertificate(item) {
      this.$documentViewer.documentViewerRsp.docUrl = item.url;
    },
    emitUpload(item) {
      this.loadTable();
    },
    loadTable() {
      let _ = this;
      let url = "/auth/documenti/listDocumenti/certificato";
      _.urlUpload = "/auth/documenti/upload/certificato";
      _.tableData = [];
      if (_.mode === "2approve" && !_.RBAC_VALIDATE) return false;
      if (_.masterId && !_.RBAC_VIEW) return false;
      if (_.masterId) {
        url += "/" + _.masterId;
        _.urlUpload += "/" + _.masterId;
      }
      if (!_.mode) {
        _.headers = [
          { text: _.$t("date_inz"), value: "dateInz", type: "date" },
          { text: this.$t("date_end"), value: "dateEnd", type: "date" },
          { text: this.$t("description"), value: "text" },
          { text: this.$t("validated"), value: "icons", type: "icons" },
          { text: this.$t("options"), value: "options", type: "buttons" },
        ];
      } else if (_.mode === "2approve") {
        url = "/auth/documenti/listDocumenti2approve";
        _.headers = [
          {
            text: _.$t("user"),
            align: "left",
            value: "fullName",
          },
          { text: _.$t("doc_type"), value: "type" },
          { text: _.$t("date_inz"), value: "dateInz", type: "date" },
          { text: _.$t("date_end"), value: "dateEnd", type: "date" },
          { text: _.$t("description"), value: "text" },
          { text: _.$t("options"), value: "options", type: "buttons" },
        ];
      } else if (_.mode === "active") {
        url = "/auth/documenti/listActiveDocument/certificato";
        _.headers = [
          {
            text: _.$t("user"),
            align: "left",
            value: "fullName",
          },
          { text: _.$t("doc_type"), value: "type" },
          { text: _.$t("date_inz"), value: "dateInz", type: "date" },
          { text: _.$t("date_end"), value: "dateEnd", type: "date" },
          { text: _.$t("description"), value: "text" },
          { text: _.$t("validated"), value: "icons", type: "icons" },
          { text: _.$t("expired"), value: "icon_expired", type: "icons" },
          { text: _.$t("options"), value: "options", type: "buttons" },
        ];
      }

      this.chiamataAxios("GET", url).then((response) => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.map(function (item) {
          // item.url = _.authorizeLink(item.url);
          item.options = [
            {
              icon: "mdi-magnify",
              function: "showCertificate",
              text: _.$t("show_certificate"),
              color: "green",
            },
          ];
          if (!_.masterId || _.RBAC_DELETE) {
            item.options.push({
              icon: "mdi-delete",
              function: "deleteCertificate",
              text: _.$t("delete_certificate"),
              color: "red",
            });
          }
          if (_.RBAC_VALIDATE) {
            item.options.push({
              icon: "mdi-thumb-up-outline",
              function: "approveDocument",
              text: _.$t("approve"),
              color: "orange",
            });
            item.options.push({
              icon: "mdi-thumb-down-outline",
              function: "rejectDocument",
              text: _.$t("reject"),
              color: "orange",
            });
          }
          switch (item.validato) {
            case 1:
              item.icons = [{ icon: "mdi-file-check-outline", color: "green" }];
              break;
            case 0:
              item.icons = [{ icon: "mdi-file-remove-outline", color: "red" }];
              break;
            default:
              item.icons = [
                { icon: "mdi-file-question-outline", color: "blue" },
              ];
          }
          if (item.scaduto) item.icon_expired = [{ icon: "mdi-clock-remove", color: "red" }];

          return item;
        });
      });
    },
  },
};
</script>
